import React, { useState } from "react";
import "./RightSidebar.css";
import SessionNotesModal from "./SessionNotesModal";
import UserHistoryPanel from "./UserHistoryPanel";

export default function RightSidebar({
  atual,
  userInfo,
  historico,
  isOwner,
  onFinalizar,
  onTransferir,
  onSalvarNota,
  timeline,
}) {
  const [notesModalOpen, setNotesModalOpen] = useState(false);

  // ===========================
  // PLACEHOLDER QUANDO NÃO HÁ SESSÃO
  // ===========================
  if (!atual) {
    return (
      <div className="col-right-sidebar">
        <div className="right-sidebar-placeholder">
          <h3>Selecione um atendimento</h3>
          <p>Ao escolher uma sessão, os detalhes aparecerão aqui.</p>
        </div>
      </div>
    );
  }

  // ===========================
  // DADOS DO ATENDIMENTO ATUAL
  // ===========================
  const {
    avatarName,
    papel,
    operadorNome,
    userId,
    idade,
    genero,
    tags = [],
  } = atual;

  const nameInitial = avatarName?.charAt(0)?.toUpperCase() || "U";

  // ===========================
  // Timeline – estilo Intercom
  // ===========================
  const formatTime = (ms) => {
    const minutes = Math.floor(ms / 60000);
    if (minutes <= 0) return "menos de 1 minuto";
    return `${minutes} minuto${minutes === 1 ? "" : "s"}`;
  };

  return (
    <div className="col-right-sidebar">
      {/* ========================================== */}
      {/* SEÇÃO 1 — CABEÇALHO DO USUÁRIO */}
      {/* ========================================== */}
      <div className="rs-user-header">
        <div className="rs-avatar">{nameInitial}</div>

        <div>
          <h2 className="rs-username">{avatarName}</h2>

          {userInfo && (
            <p className="rs-email">
              {userInfo.name} • {userInfo.email}
            </p>
          )}
        </div>
      </div>

      {/* ========================================== */}
      {/* SEÇÃO 2 — DADOS BÁSICOS */}
      {/* ========================================== */}
      <div className="rs-section">
        <h3 className="rs-section-title">Dados básicos</h3>

        <div className="rs-info-item">
          <span className="rs-label">Nome:</span>
          <span>{userInfo?.name || "—"}</span>
        </div>

        <div className="rs-info-item">
          <span className="rs-label">Email:</span>
          <span>{userInfo?.email || "—"}</span>
        </div>

        {idade && (
          <div className="rs-info-item">
            <span className="rs-label">Idade:</span>
            <span>{idade}</span>
          </div>
        )}

        {genero && (
          <div className="rs-info-item">
            <span className="rs-label">Gênero:</span>
            <span>{genero}</span>
          </div>
        )}
      </div>

      {/* ========================================== */}
      {/* SEÇÃO 3 — PERFIL AFETIVO */}
      {/* ========================================== */}
      <div className="rs-section">
        <h3 className="rs-section-title">Perfil afetivo</h3>

        <div className="rs-tag rs-tag-primary">{papel || "Não informado"}</div>

        {tags.length > 0 && (
          <div className="rs-tags-container">
            {tags.map((t, i) => (
              <span key={i} className="rs-tag rs-tag-outline">
                {t}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* ========================================== */}
      {/* SEÇÃO 4 — TIMELINE / TEMPO DE ATENDIMENTO */}
      {/* ========================================== */}
      <div className="rs-section">
        <h3 className="rs-section-title">Timeline do atendimento</h3>

        <div className="rs-info-item">
          <span className="rs-label">Iniciou há:</span>
          <span>{formatTime(timeline.minutesMs)}</span>
        </div>

        <div className="rs-info-item">
          <span className="rs-label">Tempo total online:</span>
          <span>{timeline.total}</span>
        </div>

        <div className="rs-info-item">
          <span className="rs-label">Operador atual:</span>
          <span>
            {operadorNome || "—"} {isOwner && <small>(você)</small>}
          </span>
        </div>
      </div>

      {/* ========================================== */}
      {/* SEÇÃO 5 — HISTÓRICO ANTERIOR */}
      {/* ========================================== */}
      <div className="rs-section">
        <h3 className="rs-section-title">Histórico do usuário</h3>

        <UserHistoryPanel historico={historico} userId={userId} />
      </div>

      {/* ========================================== */}
      {/* SEÇÃO 6 — NOTAS INTERNAS */}
      {/* ========================================== */}
      <div className="rs-section">
        <h3 className="rs-section-title">Notas internas</h3>

        {!atual.notaInterna && (
          <p className="rs-no-notes">Nenhuma nota adicionada.</p>
        )}

        {atual.notaInterna && (
          <div className="rs-note-box">{atual.notaInterna}</div>
        )}

        <button
          className="rs-btn rs-btn-secondary"
          onClick={() => setNotesModalOpen(true)}
        >
          Adicionar / Editar nota interna
        </button>
      </div>

      {/* ========================================== */}
      {/* SEÇÃO 7 — AÇÕES RÁPIDAS */}
      {/* ========================================== */}
      <div className="rs-section">
        <h3 className="rs-section-title">Ações rápidas</h3>

        <button className="rs-btn rs-btn-primary" onClick={onTransferir}>
          Transferir atendimento
        </button>

        <button className="rs-btn rs-btn-warning" onClick={onFinalizar}>
          Finalizar sessão
        </button>

        <button className="rs-btn rs-btn-danger">Bloquear usuário</button>

        <button className="rs-btn rs-btn-outline">Enviar avaliação</button>
      </div>

      {/* ========================================== */}
      {/* MODAL DE NOTAS INTERNAS */}
      {/* ========================================== */}
      {notesModalOpen && (
        <SessionNotesModal
          inicial={atual.notaInterna}
          onSave={(nota) => {
            onSalvarNota(nota);
            setNotesModalOpen(false);
          }}
          onClose={() => setNotesModalOpen(false)}
        />
      )}
    </div>
  );
}
